import { ParamMap } from '@angular/router';

import { SocialRouteTypeEnum } from '../enums/social-route-type.enum';


export class SocialRouteModel {
    type: SocialRouteTypeEnum;

    // only ever themeId
    value?: number;
    queryParamMap?: ParamMap;

    constructor(type: SocialRouteTypeEnum, value?: number, queryParamMap?: ParamMap) {
        this.type = type;
        this.value = value;
        this.queryParamMap = queryParamMap;
    }
}
